// Generado desde design-system/components/controls/Kbd.tsx — no editar; edita el .ts/.tsx y corre build-ds.
import { Fragment } from 'react';
import { cn } from '../../lib/cn';
const isMac = () => typeof navigator !== 'undefined' && /Mac|iPhone|iPad/.test(navigator.platform || navigator.userAgent || '');
const LABELS = {
    mod: () => (isMac() ? '⌘' : 'Ctrl'),
    ctrl: () => 'Ctrl',
    shift: () => (isMac() ? '⇧' : 'Shift'),
    alt: () => (isMac() ? '⌥' : 'Alt'),
    enter: () => '↵',
    esc: () => 'Esc',
    up: () => '↑',
    down: () => '↓',
    left: () => '←',
    right: () => '→',
    tab: () => 'Tab',
    backspace: () => '⌫',
    delete: () => 'Supr',
};
/** "mod+shift+e" → ['Ctrl','Shift','E'] (o ['⌘','⇧','E'] en Mac). */
export function formatShortcut(combo = '') {
    return combo
        .split('+')
        .filter(Boolean)
        .map((k) => (LABELS[k.toLowerCase()] ? LABELS[k.toLowerCase()]() : k.length === 1 ? k.toUpperCase() : k));
}
/** "mod+k" → "Control+K" (o "Meta+K") para aria-keyshortcuts. */
export function ariaShortcut(combo = '') {
    const map = { mod: isMac() ? 'Meta' : 'Control', ctrl: 'Control', shift: 'Shift', alt: 'Alt', enter: 'Enter', esc: 'Escape', delete: 'Delete', backspace: 'Backspace' };
    return combo
        .split('+')
        .filter(Boolean)
        .map((k) => map[k.toLowerCase()] ?? (k.length === 1 ? k.toUpperCase() : k))
        .join('+');
}
/**
 * Kbd — tecla o atajo de teclado. `combo="mod+k"` muestra Ctrl K (⌘K en Mac);
 * o pasa el texto como children. Solo informativo: el atajo se registra aparte.
 */
export function Kbd({ combo, children, className, tone = 'default' }) {
    const keys = combo ? formatShortcut(combo) : [children];
    const cap = cn('inline-flex h-5 min-w-[20px] items-center justify-center rounded-xs border px-1.5 font-mono text-caption leading-none', tone === 'inverse'
        ? 'border-[color-mix(in_srgb,var(--db-on-primary)_30%,transparent)] text-primary-on'
        : 'border-hair-2 bg-[color-mix(in_srgb,var(--db-surface-hi)_70%,transparent)] text-ink-3 shadow-[inset_0_-1px_0_var(--db-hair-2)]');
    return (<span className={cn('inline-flex items-center gap-1', className)}>
      {keys.map((k, i) => (<Fragment key={i}>
          <kbd className={cap}>{k}</kbd>
        </Fragment>))}
    </span>);
}
